import { Add, ClearRounded, FlashlightOffOutlined } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	FormControlLabel,
	IconButton,
	Radio,
	RadioGroup,
	Slider,
	Stack,
	Switch,
	Typography,
} from "@mui/material";
import CustomInputField from "components/ReplenishmentDashboard/ReusableComponents/CustomInputField/CustomInputField";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import { useEffect, useState } from "react";
import {
	consideredFacilitiesCol,
	daysToreplenishCol,
	logicProfileColumns,
	logicProfileStoreGroupingAssoc,
	logicProfileToggleColumns,
	logicProfileWarehouseAssoc,
	relookAttrStrArr,
	rosStoreGradeRelationCol,
	storeGradeRosRelationtypes,
	storeGroupingtypes,
	storeMastShortNameKey,
	storeMastStoreCodeKey,
	warehouseMappingLogicColumns,
	wearHouses,
	whMappingTypeCol,
	whMapPriorityTypesColumns,
	zonesList,
} from "../data";
import { selectOptKeyName } from "components/ReplenishmentDashboard/data";
import DragDropStores from "./DragDropStores/DragDropStores";
import { arrType, constraintsOptions, inputTypes, isNewKey, relAttrValAssocObj } from "data/globalData";
import { ReplenishmentState } from "context/ReplenishmentContext.js";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import WarehouseMappingSection from "./WarehouseMappingSection/WarehouseMappingSection";
import { ro } from "date-fns/locale";
import RenderRelookAttributes from "components/ReplenishmentDashboard/ReusableComponents/RenderRelookAttributes/RenderRelookAttributes";
import RenderAttributes, {
	RenderAttribute,
} from "components/ReplenishmentDashboard/ReusableComponents/RenderAttributes/RenderAttributes";
export const fileTypesData = [
	// { name: "Industry Type Certification", Key: "INDUSTRY_CERT" },
	{ name: "Pancard", Key: "PANCARD" },
	{ name: "GST Certificate", Key: "GST_CERT" },
	{ name: "Blank Cheque Photo Copy", Key: "BLANK_CHEQUE_PHOTO" },
];

const CreateProfileModal = ({ modalOpen, setModalOpen, callBackFun = () => {} }) => {
	const { allStores, itemMastDropdownsList, allWarehouses } = ReplenishmentState();

	const [profileColumns, setProfileColumns] = useState(Object.keys(logicProfileColumns)?.map((row) => logicProfileColumns[row]));
	const defFields = (() => {
		let obj = {};
		Object.keys(logicProfileColumns)
			?.map((row) => logicProfileColumns[row])
			?.forEach((row) => (obj[row.key] = getColDefaultValue(row)));

		Object.keys(whMapPriorityTypesColumns)
			?.map((row) => whMapPriorityTypesColumns[row])
			?.forEach((row) => {
				if (obj[row.key] === whMapPriorityTypesColumns.wh_map_zone.key) obj[row.key] = true;
				else obj[row.key] = false;
			});
		Object.keys(logicProfileToggleColumns)
			?.map((row) => logicProfileToggleColumns[row])
			?.forEach((row) => {
				// if (obj[row.key] === whMapPriorityTypesColumns.wh_map_zone.key) obj[row.key] = true;
				// else
				obj[row.key] = false;
			});
		obj[whMappingTypeCol.key] = whMapPriorityTypesColumns.wh_map_zone.key;
		obj[logicProfileWarehouseAssoc] = [];
		obj[daysToreplenishCol.key] = daysToreplenishCol.default_value;

		obj[logicProfileStoreGroupingAssoc] = Object.keys(storeGroupingtypes)?.reduce((acc, row) => {
			if (row === storeGroupingtypes.to_allocate.key) acc[row] = allStores?.map((row) => row?.[storeMastStoreCodeKey]);
			else acc[row] = [];
			return acc;
		}, {});

		obj[rosStoreGradeRelationCol.key] = storeGradeRosRelationtypes.store_grade_greater_ros.key;
		obj[consideredFacilitiesCol.key] = getColDefaultValue(consideredFacilitiesCol);
		return obj;
	})();
	const [modalData, setModalData] = useState({ ...defFields });
	const [facilitesToConsiderCol, setFacilitesToConsiderCol] = useState(consideredFacilitiesCol);

	// useEffect(() => {
	// 	if (relookAttributesObj) {
	// 		const relColumns = relookAttrStrArr
	// 			?.map((row) => relookAttributesObj[row])
	// 			.filter(Boolean)
	// 			?.map((row) => {
	// 				return {
	// 					...row,
	// 					constraints: { ...row.constraints, NOTNULL: false },

	// 					input_type: row?.input_type === inputTypes.SELECT.key ? inputTypes.MULTIPLE_SELECT.key : row?.input_type,
	// 				};
	// 			});
	// 		setProfileColumns((prev) => {
	// 			return [...Object.keys(logicProfileColumns)?.map((row) => logicProfileColumns[row]), ...relColumns]?.sort(
	// 				(a, b) => a?.sort_no - b?.sort_no
	// 			);
	// 		});
	// 		setModalData((prev) => {
	// 			return {
	// 				...prev,
	// 				...relColumns.reduce((acc, row) => {
	// 					acc[row.key] = getColDefaultValue(row);
	// 					return acc;
	// 				}, {}),
	// 			};
	// 		});
	// 	}
	// }, [relookAttributesObj]);
	useEffect(() => {
		if (itemMastDropdownsList) {
			const relColumns = profileColumns.filter(Boolean)?.map((col) => {
				return {
					...col,
					// constraints: { ...col.constraints, NOTNULL: false },
					[selectOptKeyName]: {
						type: arrType,
						list: itemMastDropdownsList,
					},
					input_type: col?.input_type === inputTypes.SELECT.key ? inputTypes.MULTIPLE_SELECT.key : col?.input_type,
				};
			});
			setProfileColumns((prev) => {
				return relColumns?.sort((a, b) => a?.sort_no - b?.sort_no);
			});
			setModalData((prev) => {
				return {
					...prev,
					...relColumns.reduce((acc, row) => {
						acc[row.key] = getColDefaultValue(row);
						return acc;
					}, {}),
				};
			});
		}
	}, [itemMastDropdownsList]);
	useEffect(() => {
		if (allWarehouses) {
			setFacilitesToConsiderCol((prev) => {
				return {
					...prev,
					[selectOptKeyName]: {
						type: arrType,
						list: allWarehouses?.map((row) => ({ name: row?.facility, key: row?.facility })),
					},
				};
			});
		}
	}, [allWarehouses]);
	const { snackBar, setSnackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const [errorObj, setErrorObj] = useState({});

	console.log(modalData, "mdfhcnbdcdbcfbdfgvdhc");

	const handleFormSubmit = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		let pendingFields = [];
		console.log("Hey Hedsfffdds");
		profileColumns?.forEach((attr) => {
			if (isColumnDefault(attr, modalData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		// warehouse pending
		let whSelectPending = [];
		modalData?.[logicProfileWarehouseAssoc]?.forEach((row) => {
			Object.keys(warehouseMappingLogicColumns)
				.map((row) => warehouseMappingLogicColumns[row])
				.forEach((attr) => {
					let obj = row;
					if (isColumnDefault(attr, obj?.[attr?.key]) && attr?.constraints[constraintsOptions.NOTNULL.key])
						whSelectPending.push(attr);
				});
		});
		if (!modalData?.[logicProfileWarehouseAssoc]?.length || whSelectPending?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: !modalData?.[logicProfileWarehouseAssoc]?.length
					? "Add warehouse mapping"
					: `Enter values for ${whSelectPending.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		try {
			const body = modalData;
			delete body["id"];
			body[logicProfileWarehouseAssoc] = body?.[logicProfileWarehouseAssoc]?.map((row) => {
				delete row["id"];
				let list = [];
				Object.keys(row).forEach((col) => {
					let regex = new RegExp(/^p\d+$/);
					if (regex.test(col)) if (row[col] !== inputTypes.SELECT.key) list[+col.slice(1, col.length)] = row[col];
				});
				list = list.filter(Boolean);
				if (!list.length) {
					throw new Error(`Select Priority for ${row?.[warehouseMappingLogicColumns.proiority_for.key].join(", ")}  `);
				}
				return {
					...row,
					[warehouseMappingLogicColumns.priority_list.key]: list,
				};
			});
			delete body?.[logicProfileStoreGroupingAssoc].id;
			const result = await axios.post("/api/replenishment/create_logic_profile", body);
			if (result?.data?.status === "success") {
				callBackFun(result?.data?.result);
				handleModalclose();
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: result?.data?.message,
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			} else {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: result?.data?.message,
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	const handleModalclose = () => {
		setModalOpen(false);
		setModalData({ ...defFields });
	};

	const handleToggleSwitchChange = (event, colData) => {
		const { name, value, type, checked } = event.target;
		setModalData((prev) => ({
			...prev,
			[colData?.key]: type === "checkbox" ? checked : value,
		}));
	};
	const handleRosStoreGradeRelationChange = (event) => {
		const { name, value, type, checked } = event.target;
		setModalData((prev) => ({
			...prev,
			[rosStoreGradeRelationCol?.key]: value,
		}));
	};

	const handleSliderChange = (event, newValue) => {
		setModalData((prev) => {
			return { ...prev, [daysToreplenishCol.key]: newValue };
		});
	};
	const handleWarehouseMappingDelete = (rowToDelte) => {
		setModalData((prev) => {
			return {
				...prev,
				[logicProfileWarehouseAssoc]: prev?.[logicProfileWarehouseAssoc]?.filter((row) => rowToDelte?.id !== row?.id),
			};
		});
	};
	const removeDropdownOptionsBasedonDependency = (column, data, options, allAttributes) => {
		if ((column?.input_type === inputTypes.SELECT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key) && options) {
			let list = [];
			console.log(column, allAttributes, options, "columnsd.........");

			let dependentCols = [];
			if (column?.dependency)
				Object.keys(column?.dependency).forEach((row) => {
					dependentCols.push(logicProfileColumns[row]);
				});
			console.log(dependentCols, column, "agfajfgdjfgujydfqjdhtg");
			if (dependentCols?.length) {
				column[selectOptKeyName]?.list?.forEach((attrVal) => {
					let push = true;
					dependentCols.forEach((col) => {
						// console.log("Checking column:", col.key, "Input Type:", col.input_type);
						// console.log("data[col.key]:", data[col.key]);
						if (data?.[col.key] && !isColumnDefault(col, data?.[col.key]))
							if (col.input_type === inputTypes.SELECT.key) {
								// console.log("Inside SELECT condition!");

								if (attrVal?.[col.key] === data?.[col.key]) {
								} else push = false;
							} else if (col.input_type === inputTypes.MULTIPLE_SELECT.key) {
								if (data?.[col.key]?.includes(attrVal?.[col.key])) {
								} else push = false;
							} else push = false;
					});
					if (push) list.push(attrVal);
				});
			} else list = column[selectOptKeyName];

			console.log("kjdfnjlasjdn", list, column);
			if (Array.isArray(list))
				return {
					type: arrType,
					list: [...new Set(list?.map((val) => val?.[column.key]))].map((row) => {
						return { name: row, key: row };
					}),
				};
			else
				return {
					type: arrType,
					list: [...new Set(list?.list?.map((val) => val?.[column.key]))].map((row) => {
						return { name: row, key: row };
					}),
				};
		} else return {};
	};
	return (
		<Dialog maxWidth="md" fullWidth open={modalOpen} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">Create Profile</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{profileColumns ? (
						<Box display="flex" columnGap={"4%"} rowGap="10px" flexWrap="wrap" width="100%">
							<RenderAttributes
								columns={profileColumns ?? []}
								data={modalData}
								setData={setModalData}
								errObj={errorObj}
								setErrorObj={setErrorObj}
								allColumns={profileColumns}
								dependencyBasedOptFilterFun={removeDropdownOptionsBasedonDependency}
								selectOptObjName={selectOptKeyName}
								width="20%"
							/>
						</Box>
					) : (
						<></>
					)}
				</Stack>
				<RadioGroup
					row
					aria-labelledby="demo-controlled-radio-buttons-group"
					name="controlled-radio-buttons-group"
					value={modalData?.[rosStoreGradeRelationCol.key]}
					onChange={(e) => handleRosStoreGradeRelationChange(e)}>
					{Object.keys(storeGradeRosRelationtypes)
						?.map((row) => storeGradeRosRelationtypes[row])
						?.map((row) => {
							return <FormControlLabel value={row.key} control={<Radio />} label={row.name} />;
						})}
				</RadioGroup>

				<Box pt={2} pb={2}>
					<RenderAttribute
						column={facilitesToConsiderCol}
						data={modalData}
						setData={setModalData}
						errObj={errorObj}
						setErrorObj={setErrorObj}
						selectOptObjName={selectOptKeyName}
						width="500px"
						disabled={modalData?.[logicProfileWarehouseAssoc]?.length > 0}
					/>
				</Box>
				{/* warehouse */}
				{/* Store Grouping */}
				<Box>
					<Typography variant="h6">Warehouse Mapping</Typography>
					<WarehouseMappingSection
						profileData={modalData}
						setProfileData={setModalData}
						disableEdit={false}
						handleDelete={handleWarehouseMappingDelete}
						wearHouses={modalData?.[consideredFacilitiesCol.key] ?? []}
					/>
				</Box>
				<Box>
					<Typography variant="h6">Store Grouping</Typography>
					<DragDropStores
						setProfileData={setModalData}
						profileData={modalData}
						storeCodeList={allStores?.map((row) => row?.[storeMastStoreCodeKey])}
						storeFullDataList={allStores}
					/>
				</Box>
				<Box sx={{ mt: 2 }} display="flex" columnGap="40px">
					<Typography gutterBottom>
						{daysToreplenishCol.name}:
						<span style={{ fontWeight: "bold", fontSize: 16 }}>{modalData?.[daysToreplenishCol.key]}</span>
					</Typography>
					<Box width="40%">
						<Slider
							value={modalData?.[daysToreplenishCol.key] ?? daysToreplenishCol?.default_value}
							onChange={handleSliderChange}
							min={0}
							max={daysToreplenishCol.max_value ?? 30}
							step={1}
							valueLabelDisplay="auto"
						/>
					</Box>
				</Box>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 300, maxHeight: 130, flexWrap: "wrap", pt: 2 }}>
					{/* TAT Switch & Input */}
					{Object.keys(logicProfileToggleColumns)
						?.map((row) => logicProfileToggleColumns[row])
						?.map((row) => {
							return (
								<FormControlLabel
									control={
										<Switch
											checked={modalData?.[row?.key] === true}
											onChange={(e) => handleToggleSwitchChange(e, row)}
											name={row?.key}
										/>
									}
									label={row?.name}
								/>
							);
						})}
				</Box>
				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" onClick={handleModalclose}>
						Cancel
					</Button>
					<Button variant="contained" type="submit">
						Create
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default CreateProfileModal;
